import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showNav: false, // false = expanded/visible, true = collapsed/hidden
};

export const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.showNav = !state.showNav;
    },
    setSidebarState: (state, action) => {
      state.showNav = action.payload;
    },
  },
});

export const { toggleSidebar, setSidebarState } = sidebarSlice.actions;
export const selectSidebarState = (state) => state.sidebar.showNav;

export default sidebarSlice.reducer;
